import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  private readonly _totalPrice = new BehaviorSubject<number | null>(null);
  public readonly totalPrice$ = this._totalPrice.asObservable();

  /**
   * Sets the total price based on the selected tickets and price scale.
   * @param price The computed total price to set.
   */
  public setTotalPrice = (price: number) => {
    this._totalPrice.next(price);
  };

  /**
   * Retrieves the total price.
   * @returns The current total price.
   */
  public getTotalPrice = () => {
    return this._totalPrice.getValue();
  };
}
